var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenHomeIconN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1059_1458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6761 3.34448C17.1631 1.83144 15.1506 1 13.0118 1C10.87 1 8.86046 1.83144 7.34742 3.34448C5.83438 4.85753 5 6.87002 5 9.00885C5 13.3364 9.09256 16.9384 11.2931 18.8715C11.5986 19.1418 11.8601 19.3739 12.0716 19.5678C12.3361 19.8146 12.6739 19.938 13.0118 19.938C13.3496 19.938 13.6875 19.8146 13.949 19.5678C14.1605 19.3739 14.4249 19.1418 14.7305 18.8715C16.9281 16.9384 21.0206 13.3364 21.0206 9.00885C21.0206 6.87002 20.1892 4.85753 18.6761 3.34448Z",
    fill: "#50AC58",
    stroke: "white",
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60809 9.04628C9.94272 9.04628 10.2427 8.92685 10.4571 8.73905C10.6715 8.9275 10.9724 9.04628 11.3074 9.04628C11.6427 9.04628 11.944 8.92685 12.1584 8.74097C12.3727 8.92814 12.6727 9.04628 13.0067 9.04628C13.3404 9.04628 13.6407 8.92814 13.8547 8.73808C14.0694 8.92685 14.3704 9.04628 14.706 9.04628C15.041 9.04628 15.3416 8.92718 15.5563 8.73905C15.7707 8.92718 16.0707 9.04628 16.4053 9.04628C17.0537 9.04628 17.5818 8.60517 17.5818 8.06326C17.5818 8.02955 17.5762 7.99552 17.5655 7.96342L16.7158 5.41501C16.6717 5.28307 16.5465 5.19382 16.4053 5.19382H9.60809C9.46691 5.19382 9.34143 5.28307 9.29764 5.41501L8.44798 7.96342C8.4372 7.99552 8.43164 8.02923 8.43164 8.06326C8.43164 8.60517 8.95941 9.04628 9.60809 9.04628ZM17.255 12.5581H16.7321V9.33489C16.6276 9.35737 16.5165 9.367 16.4053 9.367C16.0916 9.367 15.8008 9.28032 15.559 9.13585C15.3139 9.28032 15.023 9.367 14.706 9.367C14.4479 9.367 14.2028 9.30921 13.9871 9.20648V10.1503H14.6211C14.8008 10.1503 14.9479 10.2948 14.9479 10.4714C14.9479 10.6479 14.8008 10.7924 14.6211 10.7924H13.9871V12.5581H13.3335V9.33489C13.2289 9.35737 13.1211 9.367 13.0067 9.367C12.6897 9.367 12.3989 9.28032 12.1571 9.13585C11.9152 9.28032 11.6211 9.367 11.3074 9.367C10.9904 9.367 10.6996 9.28032 10.4545 9.13585C10.2127 9.28032 9.92181 9.367 9.60809 9.367C9.49698 9.367 9.38587 9.35737 9.2813 9.33489V12.5581H8.75843C8.57804 12.5581 8.43164 12.7016 8.43164 12.8792C8.43164 13.0567 8.57804 13.2002 8.75843 13.2002H17.255C17.4357 13.2002 17.5818 13.0567 17.5818 12.8792C17.5818 12.7016 17.4357 12.5581 17.255 12.5581ZM12.6178 9.84535C12.7061 9.93203 12.7322 10.0572 12.6995 10.1632C12.6832 10.2145 12.657 10.2595 12.6178 10.3012L11.461 11.4345C11.3956 11.4987 11.3139 11.5308 11.229 11.5308C11.1473 11.5308 11.0623 11.4987 11.0002 11.4345C10.8695 11.3093 10.8695 11.107 11.0002 10.9818L12.1538 9.84535C12.2812 9.72014 12.4871 9.72014 12.6178 9.84535ZM10.6506 9.96092L11.1146 9.50504C11.242 9.37984 11.4479 9.37984 11.5754 9.50504C11.7028 9.63025 11.7028 9.83571 11.5754 9.96092L11.1146 10.4136C11.0492 10.4778 10.9675 10.5067 10.8826 10.5067C10.8009 10.5067 10.7159 10.4778 10.6506 10.4136C10.5231 10.2884 10.5231 10.0861 10.6506 9.96092Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1059_1458",
    x: 0.5,
    y: 0.5,
    width: 25.0215,
    height: 27.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1059_1458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1059_1458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHomeIconN);
export default __webpack_public_path__ + "static/media/greenHomeIconN.31a6ea7141f267a90524b2ef4629849e.svg";
export { ForwardRef as ReactComponent };